module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av386-2db9df4632f4ba11fa126de70d4f1553.jpg";